import type { Appointment } from "@/types/appointments/api-types/appointment-types";
import type { Sale } from "@/types/sales/api-types/sale-types";
import type { ClientAppointmentHistoryFormValues } from "@/zod-schemas/clients/client-appointment-history-schema";
import type { ClientAppointmentUpcomingFormValues } from "@/zod-schemas/clients/client-appointment-upcoming-schema";

const noteToInput = (value: string | null | undefined): string =>
  value ?? "";

export const getClientAppointmentHistoryFormValues = (
  sales: Sale[]
): ClientAppointmentHistoryFormValues => ({
  items: sales.map((sale) => ({
    id: sale.id,
    colour_notes: noteToInput(sale.colour_notes),
    cut_notes: noteToInput(sale.cut_notes),
    product_notes: noteToInput(sale.product_notes),
    conversation_notes: noteToInput(sale.conversation_notes),
  })),
});

export const getClientAppointmentUpcomingFormValues = (
  appointments: Appointment[]
): ClientAppointmentUpcomingFormValues => ({
  items: appointments.map((appointment) => ({
    id: appointment.id,
    notes: noteToInput(appointment.notes),
  })),
});
